import { Avatar, Button, Col, Collapse, DatePicker, Form, Input, Row, Select } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import ProfileBloc from "../../../../bloc/profile_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import App_header from "../../../component/app_header/app_header";
import App_header_title_simple from "../../../component/app_header_title/app_header_title_simple";
import Base_screen from "../../base/base_screen/base_screen";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";
import "./proposal_form.css";
import AppModal from "../../../component/app_modal/app_modal";
import moment from "moment";
import QuotationBloc from "../../../../bloc/quotation_bloc";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import AppBottomBar from "../../../component/app_bottom_bar/app_bottom_bar";
import ProvideDetails from "./provideDetails";
import UploadDocuments from "./uploadDocuments";
import Review from "./review";
import ConsentAndDeclaration from "./consentAndDeclaration";
import QRCode from "react-qr-code";

class ProposalForm extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            stepHeader: [
                {
                    title: 'Provide Details',
                    status: 'process'
                },
                {
                    title: 'Upload Documents',
                    status: 'wait'
                },
                {
                    title: 'Review',
                    status: 'wait'
                },
                {
                    title: 'Consent and Declaration',
                    status: 'wait'
                },
            ],
            userDataHeader: null,
            userSettings: {},
            step: 1,
            keyword: null,
            qrModalOpen: false,
        };
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    handleSaveModalOpen = () => {
        this.setState({ isSaveModalOpen: true })
    }
    handleSaveModalClose = () => {
        this.setState({ isSaveModalOpen: false })
    }

    handleDiscardModalOpen = () => {
        this.setState({ isDiscardModalOpen: true })
    }
    handleDiscardModalClose = () => {
        this.setState({ isDiscardModalOpen: false })
    }

    handleTooltipOpen = () => {
        this.setState({ isTooltipOpen: true })
    }
    handleTooltipClose = () => {
        this.setState({ isTooltipOpen: false })
    }

    handleStopWithoutSaving = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`
    }

    handleSaveCurrentStep = () => {
        const isValidate = this.handleValidateForm();
        if (isValidate) {
            console.log("Validate", isValidate);
        } else {
            console.log("not validate", isValidate)
        }
    }

    handleGoBackStep() {
        this.setState({ step: this.state.step - 1 });
    }

    handleNextStep() {
        this.setState({ step: this.state.step + 1 })
    }

    async handleFormSubmit() {
        let data = Config.quotation.formDataMapping.personalDetails;

        data.name = this.state.name;
        data.gender = this.state.gender;
        data.idType.code = this.state.idType;
        data.idNo = this.state.nricNo;
        data.dob = moment(this.state.dob._d).format('YYYYMMDD');
        data.anb = this.state.age;
        data.occupationClass = this.state.occupationClass;
        data.occupation = this.state.occupation;
        data.natureOfBusiness = this.state.natureOfBusiness;
        data.smoker = this.state.smokerStatus;
        data.quotationDate = moment(this.state.dateOfQuotation).format('YYYYMMDD');
        console.log("Submit", data);
        let response = await QuotationBloc.saveForm(this.getQuotationId(), 'PERSONAL_DETAILS', data);
        console.log("response", response)
    }

    renderBottomBar = () => {
        return (
            <AppBottomBar
                enable={true}
                lableDiscard={'Discard'}
                lableSaveAndClose={'Save & Close'}
                lableNext={'Next'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => { this.handleNextStep() }}
                onDiscard={(e) => this.handleDiscardModalOpen()}
                onSaveAndClose={(e) => this.handleSaveModalOpen()}
            />
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                    }}
                >
                    <>
                        {/* <App_header
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        >
                            <div style={{ width: '60%' }}>
                                <AppSteps
                                    direction="horizontal"
                                    current={0}
                                    items={StepData}
                                />
                            </div>

                        </App_header> */}
                        {this.state.loading && this.loadingContent()}
                        <div
                            style={{
                                marginTop: 110,
                                paddingLeft: 42,
                                paddingRight: 42,
                                paddingBottom: 150,
                            }}
                        >
                            <div className="row m-0 w-100">
                                <App_header_title_simple
                                    title={Config.proposal.formStepData[this.state.step - 1].header}
                                    description={Config.proposal.formStepData[this.state.step - 1].subheader}
                                    handleBack={() => this.state.step === 1 ? this.handleSaveModalOpen() : this.handleGoBackStep()}
                                />
                            </div>

                            <div className="w-100 my-2 d-flex row" >
                                {
                                    this.state.step === 1 &&
                                    <ProvideDetails />
                                }
                                {
                                    this.state.step === 2 &&
                                    <UploadDocuments />
                                }
                                {
                                    this.state.step === 3 &&
                                    <Review />
                                }
                                {
                                    this.state.step === 4 &&
                                    <ConsentAndDeclaration />
                                }
                            </div>
                        </div>
                        {this.renderBottomBar()}

                        <AppModal
                            open={this.state.isSaveModalOpen}
                            handleModalClose={this.handleSaveModalClose}
                            width={'50%'}
                            title={'Do you want to stop?'}
                            subtitle={'If you stop without saving, you will loose any progress you’ve made.'}
                            negativeButtonText={'Stop without Saving'}
                            positiveButtonText={'Save & Close'}
                            handleNegativePress={this.handleStopWithoutSaving}
                            handlePositivePress={this.handleSaveCurrentStep}
                            closable={false}
                        />
                        <AppModal
                            open={this.state.isDiscardModalOpen}
                            handleModalClose={this.handleDiscardModalClose}
                            width={'50%'}
                            title={'Do you want to discard?'}
                            subtitle={'If you discard without saving, you will loose any progress you’ve made.'}
                            negativeButtonText={'Stop without Saving'}
                            positiveButtonText={'Save & Close'}
                            handleNegativePress={this.handleStopWithoutSaving}
                            handlePositivePress={this.handleSaveCurrentStep}
                            closable={false}
                        />
                        <AppModal
                            open={this.state.qrModalOpen}
                            // handleModalClose={() => window.location.href =`/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`}
                            width={'40%'}
                            title={'Scan QR Code'}
                            subtitle={<>An email has been sent to the client with <b>QR Code</b> to review the quotation and proposal. Alternatively you can directly show this <b>QR Code</b> for quick scanning.</>}
                            closable={false}
                        >
                            <div className="w-100 d-flex justify-content-center mt-3">
                                <QRCode value="https://www.npmjs.com/package/react-qr-code" />
                            </div>

                        </AppModal>
                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ProposalForm));
